<template>
<div>
	<header>
        <a href="#" @click.prevent="goBack" class="back"></a>
        <h1>Freunde von {{ who | name }}</h1>
    </header>
    <section>
    	<div v-for="friend in who.friends" class="item">
    		<dp :who="friend" />
            <header>
                <h3>
                    <router-link :to="`/profile/${friend.id}`">
                        {{ friend | name }}
                    </router-link>
                </h3>
                <div>
                    <friendship-button :who="friend" />
                </div>
            </header>
    	</div>
    </section>
</div>
</template>

<script>
import base from 'base.vue'
import friendshipButton from 'components/friendship-button.vue'
import dp from 'components/dp.vue'
import _ from 'underscore'

export default {
    mixins: [ base ],
    components: { dp, friendshipButton },
    data () {
        return {
            who: { id: -1, friends: [] }
        }
    },
    methods: {
        fetchData () {
            const that = this

            const id = this.$route.params.id == 'me' ? 
                this.user.id : 
                this.$route.params.id

            return this.$api.get('user/' + id + '/friends')
            .then(response => {
                that.who = response.data
            })
        }
    }
}

</script>


// WEBPACK FOOTER //
// friend-list.vue?09363f52